import './Colors.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import api from '../../../api';
import { ROUTE_MAP } from '../../../routes';

import * as Theme from '@fifth-gear-tech/common-components/dist/utils/StyledTheme';
const FGColors = Theme.Colors;
const { Orientation, ButtonType } = Theme;
import {
    Button,
    FormSection,
    FormContainer,
    SelectField,
} from '@fifth-gear-tech/common-components/dist/components';


/**
 * Parts Component
 * @augments {Component<Props, State>}
 */
class Colors extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            loading: true,
            list: [],
            options: [],
        };
    }

    load = () => {
        this.setState({ loading: true }, async () => {
            const list = await api.colors.getAll();
            const options = list.map((l) => ({ label: l.name, value: l.id }));
            this.setState({ loaded: true, loading: false, list, options });
        });
    }

    componentDidMount() {
        const { loaded } = this.state;
        if (!loaded) {
            this.load();
        }
    }

    goToEntity = (e) => {
        this.props.history.push(ROUTE_MAP.SETTINGS.COLOR_ID.replace(':colorId', e.value));
    }

    render() {
        const { options } = this.state;
        return (
            <div className={'Colors'}>
                <div className={'controls-container'}>
                    <FormContainer
                        title={''}
                        buttons={[
                            <Button
                                key={1}
                                className={'createNewButton'}
                                label={'Create New'}
                                type={ButtonType.Add}
                                onClick={() => {
                                    this.goToEntity({ value: 0 });
                                }}
                            />
                        ]}
                    >
                        <FormSection
                            label={'Color Band'}
                            subtext={'Select a color band or create a new color band below'}
                            colorTheme={FGColors.Grey}
                            orientation={Orientation.Mobile}
                        >
                            <SelectField label={'Color Band Name'} options={options} placeholder={'ex. RGB #1'} onChange={this.goToEntity} />
                        </FormSection>
                    </FormContainer>
                </div>
            </div>
        );
    }
}

Colors.defaultProps = {
};

Colors.propTypes = {
    history: PropTypes.shape(),
};


export default Colors;